import { suppressKeyboardEventForInput } from 'components/AgGrid/utils';
import { WorkOrderPriceTypeEnum } from 'gql/graphql';
import { getNumberFormatter } from 'pages/Project/Common/utils';

import type { ColDef, ColGroupDef } from 'ag-grid-community';
import { useMemo } from 'react';
import type { UseFormClearErrors, UseFormSetError, UseFormSetValue } from 'react-hook-form/dist/types/form';

import { VolumeCellRendererComponent } from '../components/VolumeCellRendererComponent';

interface IUseMoveVolumesBetweenSeasonsColumns {
    setValue: UseFormSetValue<any>;
    setError: UseFormSetError<any>;
    clearErrors: UseFormClearErrors<any>;
    volumesWithErrors: string[];
    coefficientsIds?: number[];
}

const cellStyle = (params: any) =>
    params.data.type === WorkOrderPriceTypeEnum.Uer ? { background: 'var(--color-bg-stripe)' } : undefined;

export const useMoveVolumesBetweenSeasonsColumns = (props: IUseMoveVolumesBetweenSeasonsColumns) => {
    const { setValue, coefficientsIds, setError, clearErrors, volumesWithErrors } = props;

    return useMemo<(ColDef | ColGroupDef)[]>(
        () => [
            {
                headerName: 'Шифр',
                field: 'code',
                width: 250,
                cellStyle,
            },
            {
                headerName: 'Остаток',
                field: 'remainder',
                width: 250,
                valueFormatter: getNumberFormatter(3, 6),
                cellStyle,
            },
            {
                headerName: 'Объем',
                field: 'volume',
                width: 242,
                cellRenderer: VolumeCellRendererComponent,
                cellRendererParams: {
                    onChange: setValue,
                    idsToDuplicate: coefficientsIds,
                    setError,
                    clearErrors,
                    volumesWithErrors,
                    errorMessage: 'Введенное значение превышает остаток',
                    decimalScale: 6,
                    duplicatesAreNotEditable: true,
                },
                valueFormatter: getNumberFormatter(3),
                suppressKeyboardEvent: suppressKeyboardEventForInput,
                cellStyle,
            },
        ],
        [clearErrors, coefficientsIds, setError, setValue, volumesWithErrors],
    );
};
